export const nartbaev = {
    id: "nartbaev",
    name: { ru: "Нартбаев Есмурат Кажымуханович", kz: "Нартбаев Есмұрат Кажымуханұлы" },
    position: {
      ru: "Хирург (детский, взрослый), травматолог-ортопед (детский, взрослый) - высшая категория",
      kz: "Хирург (балалар, ересектер), травматолог-ортопед (балалар, ересектер) – жоғары санатты"
    },
    department: "specialists",
    image: "/team_photoes/new/Есмұрат Кажымуханұлы.svg",
    experience: {
      ru: "45 лет (37 лет хирургический стаж)",
      kz: "45 жыл (37 жыл хирургиялық тәжірибе)"
    },
    education: {
      ru: `1980–1987 — Алматинский государственный медицинский институт, Педиатрический факультет, специальность — педиатрия
1987–1988 — Субординатура по детской хирургии, г. Талдыкорган
1988–1999 — Специализация по общей хирургии и травматологии-ортопедии`,
      kz: `1980–1987 — Алматы мемлекеттік медициналық институты, Педиатрия факультеті, мамандығы — педиатрия
1987–1988 — Балалар хирургиясы бойынша субординатура, Талдықорған қ.
1988–1999 — Жалпы хирургия және травматология-ортопедия бойынша мамандық`
    },
    specialization: {
      ru: "Детская и взрослая хирургия, травматология-ортопедия",
      kz: "Балалар мен ересектер хирургиясы, травматология-ортопедия"
    },
        work: {
      ru: `• 1987–1996 — Детский хирург, обл. детская больница г. Талдыкорган
• 1996–2000 — Врач-анестезиолог, ЦГБ г. Талдыкорган
• 2000–2007 — Хирург, затем заведующий отделением, ЦГБ г. Талдыкорган
• 2007–2018 — Врач-хирург и заведующий отделением, АО ННЦМД г. Астана
• 2018–по настоящее время — Независимый медицинский эксперт: хирург и травматолог-ортопед (детский, взрослый) в ОО "Ассоциация независимых медицинских экспертов РК"
• 2019–2022 — Хирург-травматолог-ортопед в КФ ИМС, РДЦ, ТОО Green Clinic, Университетский центр здоровья Назарбаев Университета
• 2022–2025 — ТОО Green Clinic — хирург (детский, взрослый), травматолог-ортопед (детский, взрослый)
• 2025–по настоящее время — хирург (детский, взрослый), травматолог-ортопед (детский, взрослый) в ГККП "СПОРТИВНЫЙ МЕДИЦИНСКИЙ ЦЕНТР ГОРОДА АСТАНЫ" `,
      kz: `• 1987–1996 — Балалар хирургы, Талдықорған қ. облыстық балалар ауруханасы
• 1996–2000 — Анестезиолог дәрігері, Талдықорған қ. орталық қалалық ауруханасы
• 2000–2007 — Хирург, кейін бөлім меңгерушісі, Талдықорған қ. орталық қалалық ауруханасы
• 2007–2018 — Хирург дәрігері және бөлім меңгерушісі, Астана қ. ҰМООМ АҚ
• 2018–қазіргі уақытқа дейін — Тәуелсіз медициналық сарапшы: хирург және травматолог-ортопед (балалар, ересектер) — ҚР Тәуелсіз медициналық сарапшылар қауымдастығы қоғамдық бірлестігінде
• 2019–2022 — КФ ИМС, РДЦ, «Green Clinic» ЖШС, Назарбаев Университетінің Денсаулық орталығында хирург-травматолог-ортопед
• 2022–2025 — «Green Clinic» ЖШС — хирург (балалар, ересектер), травматолог-ортопед (балалар, ересектер)
• 2025–қазіргі уақытқа дейін — хирург (балалар, ересектер), травматолог-ортопед (балалар, ересектер) — ГККП "АСТАНА ҚАЛАСЫНЫҢ СПОРТТЫҚ МЕДИЦИНАЛЫҚ ОРТАЛЫҒЫ" АСТАНА ҚАЛАСЫ НДЕ`
    },
certificates: {
    ru: `Сертификаты и квалификация:
Детский хирург — высшая категория (до 17.03.2027)
Хирург (взрослый) — высшая категория (до 11.10.2028)
Травматолог-ортопед (детский и взрослый) — высшая категория (до 30.12.2029)


Достижения:
Нагрудный знак МЗ РК «Үздік дәрігер» (2007)
Почетные грамоты от Минздрава, партии «Нұр Отан», Акима г. Астана и Президента РК
Победитель номинации «Лучший врач в сфере здравоохранения» — 2023 и 2024 гг.`,
    kz: `Сертификаттар және біліктілік:
Балалар хирургы — жоғары санат (17.03.2027-ге дейін)
Хирург (ересектер) — жоғары санат (11.10.2028-ге дейін)
Травматолог-ортопед (балалар мен ересектер) — жоғары санат (30.12.2029-ға дейін)


Жетістіктері:
ҚР ДСМ «Үздік дәрігер» белгісі (2007)
Денсаулық сақтау министрлігінен, «Нұр Отан» партиясынан, Астана қ. әкімінен және ҚР Президентінен құрмет грамоталары
«Денсаулық сақтау саласындағы үздік дәрігер» номинациясының жеңімпазы — 2023 және 2024 жж.`,
  }
  };
